<template>
  <ui-content title="Agencia Reporte">
    <ui-card v-if="loading.view == false">
      <ValidationObserver ref="form">
        <div class="row form-row mb-2">
          <div class="col-lg-3">
            <label for="" class="form-label">Agencia:</label>
            <InputSelect
              v-model="form.agencia"
              :options="containers.agencias"
              :rules="'required'"
              :name="'Agencia'"
              :vid="'agencia'"
              label="nombre"
            ></InputSelect>
          </div>
          <div class="col-lg-3">
            <label for="" class="form-label">Fecha Inicio:</label>
            <InputDatepicker
              v-model="form.fechaInicio"
              rules="required"
              name="Fecha Inicio"
              input-class="form-control form-control-sm"
            ></InputDatepicker>
          </div>
          <div class="col-lg-3">
            <label for="" class="form-label">Fecha Fin:</label>
            <InputDatepicker
              v-model="form.fechaFin"
              rules="required"
              name="Fecha Fin"
              input-class="form-control form-control-sm"
            ></InputDatepicker>
          </div>
        </div>
      </ValidationObserver>
      <div class="form-group">
        <button
          class="btn btn-primary"
          @click="onSearch"
          :disabled="loading.search"
        >
          Buscar
        </button>
        <template v-if="containers.liquidaciones.length">
          <button class="btn btn-outline-secondary ml-2" @click="print">
            Imprimir
          </button>
          <button class="btn btn-outline-success ml-2" @click="generateExcel">
            Excel
          </button>
        </template>
      </div>
      <hr />
      <div
        v-for="(grupo, idx) in containers.liquidaciones"
        :key="idx"
        class="row mb-8"
      >
        <div class="col-xl-10">
          <p><strong>Nombre:</strong> {{ grupo.pasajero }}</p>
          <DetalleLiquidacionTable
            :rows="grupo.items"
            :total="grupo.total"
            :columns="detailColumns"
          />
        </div>
      </div>
    </ui-card>
  </ui-content>
</template>
<script>
import EndosadosTable from "../../endosados/components/EndosadosTable.vue";
import InputDatepicker from "../../shared/components/InputDatepicker.vue";
import InputSelect from "../../shared/components/InputSelect.vue";
import { BTableLite } from "bootstrap-vue";
import DatePicker from "vue2-datepicker";
import reportLiquidacionesPdf from "../pdf/reporteLiquidaciones.pdf";
import DetalleLiquidacionTable from "../../liquidaciones/components/DetalleLiquidacionTable.vue";
import total from "../../liquidaciones/helpers/total.helper";

export default {
  components: {
    DatePicker,
    BTableLite,
    InputSelect,
    InputDatepicker,
    EndosadosTable,
    DetalleLiquidacionTable
  },
  data() {
    return {
      form: {
        agencia: null,
        fechaInicio: "",
        fechaFin: ""
      },
      reportes: [],
      containers: {
        agencias: [],
        liquidaciones: []
      },
      loading: {
        view: true,
        search: false
      }
    };
  },
  async created() {
    const vm = this;

    try {
      let response = await vm.axios.get("/agencias");
      vm.containers.agencias = response.data.content;

      vm.loading.view = false;
    } catch (error) {
      console.log({ error });
    }
  },
  computed: {
    usuarios() {
      const vm = this;
      let usuarios = vm.reportes.map(item => item.usuarioCreador);
      usuarios = [...new Set(usuarios)];
      return usuarios;
    },
    agencia() {
      if (!this.form.agencia) return "";
      return (
        this.containers.agencias.find(
          item => item.idAgencia == this.form.agencia
        )?.nombre || ""
      );
    },
    detailColumns() {
      return ["fecha", "servicio", "hotel", "tipo", "moneda", "monto"];
    }
  },
  methods: {
    async onSearch() {
      const vm = this;

      const validated = await vm.$refs.form.validate();

      if (!validated) {
        vm.$toast.fire({
          title: "Completa los campos requeridos",
          icon: "warning"
        });
        return;
      }

      if (vm.$dayjs(vm.form.fechaInicio) > vm.$dayjs(vm.form.fechaFin)) {
        return vm.$toast.fire(
          "Fecha inicio no puede ser mayor a fecha fin",
          "",
          "warning"
        );
      }

      vm.containers.liquidaciones = [];
      vm.loading.search = true;

      try {
        const response = await vm.axios.get(`/reportes/liquidaciones`, {
          params: {
            idAgencia: vm.form.agencia.idAgencia,
            fechaInicio: vm.form.fechaInicio,
            fechaFin: vm.form.fechaFin
          }
        });

        let liquidaciones = response.data.reduce((dict, item) => {
          if (!dict[item.idLiquidacion]) {
            dict[item.idLiquidacion] = {
              pasajero: item.pasajero,
              items: []
            };
          }
          dict[item.idLiquidacion].items.push({
            ...item,
            tipo: item.servicioTipo,
            monto: item.precio,
            fecha: this.$options.filters.date(item.fecha)
          });
          return dict;
        }, {});

        liquidaciones = Object.values(liquidaciones);

        liquidaciones = liquidaciones.map(liquidacion => {
          const items = liquidacion.items.filter(
            item => Number(item.monto) != 0
          );

          return {
            ...liquidacion,
            total: total(items),
            items
          };
        });

        this.containers.liquidaciones = liquidaciones;
      } catch (error) {
        console.error(error);
      } finally {
        vm.loading.search = false;
      }
    },
    print() {
      const {
        agencia: { nombre: agencia },
        fechaInicio,
        fechaFin
      } = this.form;

      const header = {
        agencia,
        fechaInicio: this.$options.filters.date(fechaInicio),
        fechaFin: this.$options.filters.date(fechaFin)
      };

      const liquidaciones = JSON.parse(
        JSON.stringify(this.containers.liquidaciones)
      );

      liquidaciones.forEach(liquidacion => {
        liquidacion.items = liquidacion.items.slice().map(item => ({
          ...item,
          moneda: {
            alignment: "center",
            text: item.moneda
          },
          monto: {
            alignment: "right",
            text: item.monto
          }
        }));

        for (const [moneda, total] of Object.entries(liquidacion.total)) {
          liquidacion.items.push({
            fecha: {
              colSpan: 5,
              alignment: "right",
              text: `TOTAL ${moneda}`
            },
            servicio: "",
            hotel: "",
            tipo: "",
            monto: {
              alignment: "right",
              text: this.$options.filters.number(total, 2)
            }
          });
        }
      });

      reportLiquidacionesPdf({
        header,
        liquidaciones,
        userMark: this.$store.state.user,
        dateMark: this.$dayjs().format("DD-MM-YY HH:mm")
      });
    },
    async generateExcel() {
      const response = await this.axios.post(
        "/reportes/liquidaciones/excel",
        {
          liquidaciones: this.containers.liquidaciones
        },
        {
          responseType: "blob"
        }
      );

      const url = URL.createObjectURL(response.data);

      // create "a" HTLM element with href to file & click
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Reporte Liquidaciones.xlsx"); //or any other extension
      document.body.appendChild(link);

      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  }
};
</script>
